/**
 * 判断 Object 中是否有对应的属性
 * @param object 待判断的对象
 * @param key 待检查的属性名
 * @returns {boolean} 返回属性是否存在
 */
export function hasOwnProperty(object: unknown, key: string) {
  return object && Object.prototype.hasOwnProperty.call(object, key);
}

/**
 * 判断是否为对象
 * @param value 待判断的值
 */
export function isObject(value: unknown) {
  return Object.prototype.toString.call(value) === '[object Object]';
}
